<template>
  <div>
    <ViewLiquidation/>
  </div>
</template>

<script>
// @ is an alias to /src
import ViewLiquidation from '@/components/ViewLiquidationApproval.vue'

export default {
  name: 'approve-liquidation-view',
  components: {
    ViewLiquidation
  }
}
</script>
